import Api, { configFormData } from "@/config/Api";

export default {
  getDebitNotes(options = {}) {
    return Api().get(`/debit-notes`, options);
  },
  getDebitNoteId(debitNoteId) {
    return Api().get(`/debit-notes/${debitNoteId}`);
  },
  addDebitNotes(data) {
    return Api().post("/debit-notes", data);
  },
  updateDebitNoteId(debitNoteid, data) {
    return Api().put(`/debit-notes/${debitNoteid}`, data);
  },
  deleteDebitNoteId(debitNoteid) {
    return Api().delete(`/debit-notes/${debitNoteid}`);
  },
  sendDebitNoteSRI(data) {
    return Api().post(`/sri/signature/debit-note`, data);
  },
  debitNoteDownload({ id }) {
    return Api().get(`/u/download/debit-note?id=${id}`, {
      responseType: "arraybuffer"
    });
  },
  sendDebitNoteEmail({ data }) {
    return Api().post(`/debit-notes/send-email`, data, configFormData);
  },
  updateDebitNoteStatusNuled(data) {
    return Api().post(`/debit-notes/nuled`, data);
  },
  // ════════ Métodos Batch (Optimizados para acciones masivas) ════════
  /**
   * Actualizar estado de múltiples notas de débito en un lote
   * @param {Array} debitNoteIds - Array de IDs
   * @param {Object} statusData - Datos de estado a actualizar
   */
  updateDebitNoteStatusBatch(debitNoteIds, statusData) {
    return Api().post(`/status/debit-notes`, {
      debit_note_ids: debitNoteIds,
      ...statusData
    });
  }
};
